

























































































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import PagingUnit from '@/components/paging/paging.vue';
import { institutionServer, patrolManagementServe, professionServer } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';

import ReceiveEdit from './unit/patrol-receive-edit.vue';
import PatrolReceiveDetail from './unit/patrolReceiveDetail.vue';
import { arrayToTree } from '@/util/array';

@Component({
  components: { CollapseTransition, ReceiveEdit, PatrolReceiveDetail, PagingUnit },
  mixins: [TableStripe],
})
export default class PatrolReceive extends Vue {
  private postList: any = []; // 岗位列表
  private spaceList: any = []; // 单位列表
  private deptList: any = []; // 部门列表

  showFlag = 1;
  row: any = {
    id: '',
  };

  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 数据总共多少条

  filterForm: any = {
    name: '', // 巡检名称
    departId: '', // 部门id
    postId: '', // 岗位id
    isEnable: null, // 是否启用
    spaceId: '', // 单位id
  };
  formShow = false; // 是否显示表单搜索
  // table数据
  tableData: any[] = [];

  private receiveData: any = {};
  /**
   * @desc  分页发生改变触发，获取到新的 table 数据。
   */
  getListData() {
    this.getAllData();
  }

  /**
   *【按钮】添加按钮点击
   * @Params
   * @return
   **/
  handleAddBtnClick() {
    const receiveEditComponent: any = this.$refs['receiveEdit'];
    receiveEditComponent.showAddDialog();
  }

  /**
   *【表格】表格详情按钮
   * @Params
   * @return
   **/
  handleTableDetailBtnClick(data: any) {
    this.showFlag = 2;
    this.row.id = data.id;
  }

  /**
   *【表格】表格编辑按钮
   * @Params
   * @return
   **/
  handleTableEditBtnClick(data: any) {
    this.receiveData = data;
    const receiveEditComponent: any = this.$refs['receiveEdit'];
    receiveEditComponent.showEditDialog(data.id);
  }

  /**
   *【表格】表格删除按钮
   * @Params
   * @return
   **/
  handleTableDeleteBtnClick(data: any) {
    this.$confirm('此操作将永久删除该巡检任务, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.removeReceiveData(data.id);
        this.getAllData();
      })
      .catch(() => {});
  }

  /**
   *【接口】删除巡检任务配置
   * @Params
   * @return
   **/
  async removeReceiveData(ids: any) {
    try {
      const res: any = await patrolManagementServe.deletePatrolTaskReceive(ids);
      this.getAllData();
      if (res.code === '200') {
        this.$message.success('您成功删除了记录。');
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   *【岗位编辑窗口】巡检任务配置编辑窗口提交请求成功
   * @Params
   * @return
   **/
  handleEditResponse() {
    this.getAllData();
  }
  /**
   *【岗位编辑窗口】巡检任务配置编辑窗口提交请求成功
   * @Params
   * @return
   **/
  handleInfoResponse() {
    this.showFlag = 1;
    this.getAllData();
  }

  /**
   * @desc Vue 创建数据生命周期
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取所有数据
    this.getCompanyList();
    this.getSpaceDeptList();
    this.getPostList({});
    this.getAllData();
  }
  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getAllData() {
    // 获取所有数据
    patrolManagementServe
      .getPatrolTaskReceiveListData({
        name: this.filterForm.name ? this.filterForm.name : null,
        enableFlag: this.filterForm.isEnable,
        spaceDepartmentId: this.filterForm.departId ? this.filterForm.departId : null,
        spacePostId: this.filterForm.postId ? this.filterForm.postId : null,
        spaceId: this.filterForm.spaceId ? this.filterForm.spaceId : null,
        pageNo: (this.queryDataForm as any).pageNo,
        pageSize: (this.queryDataForm as any).pageSize,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      })
      .catch((error: any) => {
        this.$message.error('获取失败,请稍后重试!');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击查询按钮触发，查询符合条件的内容
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    // 获取到符合搜索条件的数据
    (this.queryDataForm as any).pageNo = 1;
    this.getAllData();
  }

  /**
   *【接口】获取单位
   * @Params
   * @return
   **/
  async getCompanyList() {
    try {
      const res: any = await institutionServer.getCompanyList({});
      if (res.code === '200') {
        this.spaceList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   *【接口】获取岗位
   * @Params
   * @return
   **/
  async getPostList(opts: object) {
    try {
      const res: any = await professionServer.getPageDataAll(opts);
      if (res.code === '200') {
        this.postList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }
  /**
   *【接口】获取部门
   * @Params
   * @return
   **/
  async getSpaceDeptList() {
    try {
      const res: any = await institutionServer.getDeptAndSubDeptList({});
      if (res.code === '200') {
        this.deptList = arrayToTree(res.data);
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置表单内容
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields();
    (this.queryDataForm as any).pageNo = 1;
    this.filterForm = {};
    // 获取全部数据
    this.getAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏和显示按钮触发，控制表单搜索内容是否显示
   * @param1 暂无
   * @returns 暂无
   */
  setFormShow() {
    this.formShow = !this.formShow;
  }
}
